<template>
  <v-dialog persistent :value="value" @input="$emit('input')" max-width="500px">
    <v-card>
      <v-toolbar dense class="">
        <v-toolbar-title>Enter Version Name</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="closeModal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
        <!-- Popup content -->
        <v-card>
          <v-card-text>
              <v-text-field
                label=""
                v-model="versionNo"
                :error-messages="versionErrors"
                counter
                @input="$v.versionNo.$touch()"
                @blur="$v.versionNo.$touch()"
                @keyup.enter="confirmPasscode"
              ></v-text-field>
          </v-card-text>
          <!-- Footer -->
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="closeModal"> Close </v-btn>
            <v-btn class="success" @click="confirmVersionNo">Confirm</v-btn>
          </v-card-actions>
        </v-card>
    </v-card>
  </v-dialog>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { validationMixin } from 'vuelidate';

export default {
  name: 'VersionNoModal',
  props: {
    value: Boolean
  },
  mixins: [validationMixin],
  data () {
    return {
      versionNo: ''
    }
  },
  validations: {
    versionNo: {
      required
    }
  },
  computed: {
    versionErrors() {
      const errors = [];
      if (!this.$v.versionNo.$dirty) return errors;
      !this.$v.versionNo.required && errors.push('PIN is required');
      return errors;
    }
  },
  methods: {
    confirmVersionNo: function () {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$swal({
          type: 'error',
          title: `Invalid Version No`,
          text: 'Make sure you filled the version No correctly.'
        });
        return;
      }
      this.$emit('success', this.versionNo)
      this.closeModal()
      return;
    },
    closeModal: function () {
      this.$v.$reset()
      this.$emit('input')
      this.versionNo = ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// VersionNoModal.vue?5027938c